import Crud from '../views/ChecklistTemplate/Crud'
import Entity from '../views/ChecklistTemplate/Add'
import View from '../views/Checklist/View'

let routes = {
    path: '/checklisttemplates',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/checklisttemplates/add',
            name: 'NewChecklistTemplate',
            component: Entity,
            meta: {
                perfil_id: ['1', '6', '7'] // Administradores e perfil 6
            }
        },
        {
            path: '/checklisttemplates/edit/:id?',
            name: 'EditChecklistTemplate',
            component: Entity,
            meta: {
                perfil_id: ['1', '6', '7'] // Administradores e perfil 6
            }
        },
        {
            path: '/checklisttemplates/duplicate/:id',
            name: 'DuplicateChecklistTemplate',
            component: Entity,
            meta: {
                perfil_id: ['1', '6', '7'] // Administradores e perfil 6
            }
        },
        {
            path: '/checklisttemplates/view/:id?',
            name: 'ViewChecklistTemplate',
            component: View,
            meta: {
                perfil_id: ['1', '6', '7'] // Apenas administradores e gestores de empresa
            }
        },
        {
            path: '/checklisttemplates',
            name: 'list-checklisttemplates',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Checklists',
                breadcrumb: [
                    {
                        text: 'Checklists',
                        active: true,
                    },
                ],
                    perfil_id: ['1', '6', '7'] // Administradores e perfil 6
            },
        },
    ]
};


export default routes